import {ChordAnnotationBlock} from "./ChordAnnotationBlock.js";

export class ChordTrack {
    constructor(jsonStructure) {
        this.chords = [];
        this.track_id = 'chord-track'
        // console.log('OSDEBUG2 chord track json structure: ', jsonStructure)
        for (const annotationBlock of jsonStructure.chords) {
            this.chords.push(new ChordAnnotationBlock(annotationBlock))
        }
    }
}